/* eslint-disable */
import React, { Component } from 'react';
import './ImageCropper.css';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import { Modal, Button, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import { dataURItoBlob } from './../../../static/utils';

class ImageCropper extends Component {
    constructor(props) {
        super(props);
    }

    _crop() {
        const dataUrl = this.refs.cropper.getCroppedCanvas().toDataURL();
    }

    saveImage = () => {
        const { toggle, onDrop } = this.props;
        const blob = dataURItoBlob(this.refs.cropper.getCroppedCanvas().toDataURL());
        onDrop(blob);
        toggle();
    };

    render() {
        const { modal, toggle, currentImage } = this.props;
        return (
            <Modal isOpen={modal} toggle={toggle} className="crop-image-modal">
                <ModalHeader toggle={toggle}>Crop Image</ModalHeader>
                <ModalBody>
                    <Cropper
                        ref="cropper"
                        src={currentImage}
                        style={{ height: 400, width: '100%' }}
                        // Cropper.js options
                        aspectRatio={5 / 4}
                        guides={false}
                        crop={this._crop.bind(this)}
                    />
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={this.saveImage}>
                        Save
                    </Button>{' '}
                    <Button color="secondary" onClick={toggle}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }
}

export default ImageCropper;
